const SuperRoutes = [
  {
    path: "/",
    name: "Dashboard",
    component: () => import("./Dashboard.vue"),
    children: [
      {
        name: 'IndicatorsListPage',
        path: 'indicators',
        component: () => import('./pages/Indicator/IndicatorListPage.vue'),
      },
      {
        name: 'AudienceCreativeListPage',
        path: 'experiences',
        component: () => import('./pages/AudienceCreative/AudienceCreativeListPage.vue'),
        children: [
          {
            name: 'AudienceCreativeBulkEditPage',
            path: 'edit',
            component: () => import('./pages/AudienceCreative/AudienceCreativeBulkEditPage.vue')
          },
          {
            name: 'AudienceCreativePreviewPage',
            path: ':audienceCreativeId/preview',
            component: () => import('./pages/AudienceCreative/AudienceCreativePreviewPage.vue')
          },
        ]
      },
      {
        name: 'AudienceCreativeShowPage',
        path: 'experiences/:audienceCreativeId',
        component: () => import('./pages/AudienceCreative/AudienceCreativeShowPage.vue')
      },
      {
        name: 'AudienceCreativeCreatePage',
        path: 'experiences/create',
        component: () => import('./pages/AudienceCreative/AudienceCreativeCreatePage.vue')
      },
      {
        name: 'AudienceCreativeEditPage',
        path: 'experiences/:audienceCreativeId/edit',
        component: () => import('./pages/AudienceCreative/AudienceCreativeEditPage.vue')
      },
      {
        name: 'VenueListPage',
        path: 'venues',
        component: () => import('./pages/Venue/VenueListPage.vue'),
        children: [
          {
            name: 'VenueBulkEditPage',
            path: 'edit',
            component: () => import('./pages/Venue/VenueBulkEditPage.vue')
          },
        ]
      },
      {
        name: 'VenueShowPage',
        path: 'venues/:venueId',
        component: () => import('./pages/Venue/VenueShowPage.vue')
      },
      {
        name: 'VenueCreatePage',
        path: 'venues/create',
        component: () => import('./pages/Venue/VenueCreatePage.vue')
      },
      {
        name: 'VenueEditPage',
        path: 'venues/:venueId/edit',
        component: () => import('./pages/Venue/VenueEditPage.vue')
      },
      {
        name: 'SpaceListPage',
        path: 'inventory',
        component: () => import('./pages/Space/SpaceListPage.vue'),
        children: [
          {
            name: 'SpaceBulkEditPage',
            path: 'edit',
            component: () => import('./pages/Space/SpaceBulkEditPage.vue')
          },
        ]
      },
      {
        name: 'SpaceShowPage',
        path: 'inventory/:spaceId',
        component: () => import('./pages/Space/SpaceShowPage.vue')
      },
      {
        name: 'SpaceCreatePage',
        path: 'inventory/create',
        component: () => import('./pages/Space/SpaceCreatePage.vue')
      },
      {
        name: 'SamplingSpaceEditPage',
        path: 'inventory/sampling/:spaceId/edit',
        component: () => import('./pages/Space/SamplingSpaceEditPage.vue')
      },
      {
        name: 'OnsiteSpaceEditPage',
        path: 'inventory/onsite/:spaceId/edit',
        component: () => import('./pages/Space/OnsiteSpaceEditPage.vue')
      },
      {
        name: 'OmnichannelSpaceEditPage',
        path: 'inventory/omnichannel/:spaceId/edit',
        component: () => import('./pages/Space/OmnichannelSpaceEditPage.vue')
      },
      {
        name: 'AudienceAvailabilityListPage',
        path: 'availabilities',
        component: () => import('./pages/AudienceAvailability/AudienceAvailabilityListPage.vue'),
        children: [
          {
            name: 'AudienceAvailabilityBulkEditPage',
            path: 'edit',
            component: () => import('./pages/AudienceAvailability/AudienceAvailabilityBulkEditPage.vue')
          },
          {
            name: 'AudienceAvailabilityPreviewPage',
            path: ':audienceAvailabilityId/preview',
            component: () => import('./pages/AudienceAvailability/AudienceAvailabilityPreviewPage.vue')
          },
        ]
      },
      {
        name: 'AudienceAvailabilityShowPage',
        path: 'availabilities/:audienceAvailabilityId',
        component: () => import('./pages/AudienceAvailability/AudienceAvailabilityShowPage.vue')
      },
      {
        name: 'AudienceListingListPage',
        path: 'listings',
        component: () => import('./pages/AudienceListing/AudienceListingListPage.vue'),
      },
      {
        name: 'AudienceListingShowPage',
        path: 'listings/:audienceListingId/:tab?',
        component: () => import('./pages/AudienceListing/AudienceListingShowPage.vue')
      },
      {
        path: "/calendar",
        name: "CalendarPage",
        component: () => import("./pages/FullCalendar/CalendarPage.vue")
      },
      {
        path: "/event-sets",
        name: "EventSetListPage",
        component: () => import("./pages/EventSet/EventSetListPage.vue")
      },
      {
        path: "/event-sets/:eventSetId",
        name: "EventSetShowPage",
        component: () => import("./pages/EventSet/EventSetShowPage.vue")
      },
      {
        path: "/event-sets/:eventSetId/edit",
        name: "EventSetEditPage",
        component: () => import("./pages/EventSet/EventSetEditPage.vue")
      },
      {
        path: "/event-sets/create",
        name: "EventSetCreatePage",
        component: () => import("./pages/EventSet/EventSetCreatePage.vue")
      },
      {
        path: "/members",
        name: "MemberListPage",
        component: () => import("./pages/Member/MemberListPage.vue")
      },
      {
        path: "/members/:memberId",
        name: "MemberShowPage",
        component: () => import("./pages/Member/MemberShowPage.vue")
      },
      {
        path: "/members/:memberId/edit",
        name: "MemberEditPage",
        component: () => import("./pages/Member/MemberEditPage.vue")
      },
      {
        path: "/members/create",
        name: "MemberCreatePage",
        component: () => import("./pages/Member/MemberCreatePage.vue")
      },
      {
        path: "/suppliers",
        name: "SupplierListPage",
        component: () => import("./pages/Supplier/SupplierListPage.vue")
      },
      {
        path: "/suppliers/:supplierId",
        name: "SupplierShowPage",
        component: () => import("./pages/Supplier/SupplierShowPage.vue"),
        children: [
          {
            path: "experiences/:audienceCreativeId/preview",
            name: "SupplierAudienceCreativePreviewPage",
            component: () => import("./pages/Supplier/AudienceCreative/AudienceCreativePreviewPage.vue")
          },
          {
            path: "experiences/edit",
            name: "SupplierAudienceCreativeBulkEditPage",
            component: () => import("./pages/Supplier/AudienceCreative/AudienceCreativeBulkEditPage.vue")
          },
          {
            path: "venues/edit",
            name: "SupplierVenueBulkEditPage",
            component: () => import("./pages/Supplier/Venue/VenueBulkEditPage.vue")
          },
        ]
      },
      {
        path: "/suppliers/:supplierId/edit",
        name: "SupplierEditPage",
        component: () => import("./pages/Supplier/SupplierEditPage.vue")
      },
      {
        path: "/suppliers/create",
        name: "SupplierCreatePage",
        component: () => import("./pages/Supplier/SupplierCreatePage.vue")
      },
      {
        path: "/organizers",
        name: "OrganizerListPage",
        component: () => import("./pages/Organizer/OrganizerListPage.vue")
      },
      {
        path: "/organizers/:organizerId",
        name: "OrganizerShowPage",
        component: () => import("./pages/Organizer/OrganizerShowPage.vue"),
        children: [
          {
            path: "experiences/:audienceCreativeId/preview",
            name: "OrganizerAudienceCreativePreviewPage",
            component: () => import("./pages/Organizer/AudienceCreative/AudienceCreativePreviewPage.vue")
          },
          {
            path: "experiences/edit",
            name: "OrganizerAudienceCreativeBulkEditPage",
            component: () => import("./pages/Organizer/AudienceCreative/AudienceCreativeBulkEditPage.vue")
          },
          {
            path: 'inventory/edit',
            name: 'OrganizerSpaceBulkEditPage',
            component: () => import('./pages/Organizer/Space/SpaceBulkEditPage.vue')
          },
        ]
      },
      {
        path: "/organizers/:organizerId/edit",
        name: "OrganizerEditPage",
        component: () => import("./pages/Organizer/OrganizerEditPage.vue")
      },
      {
        path: "/organizers/:organizerId/password",
        name: "OrganizerPasswordPage",
        component: () => import("./pages/Organizer/OrganizerPasswordPage.vue")
      },
      {
        path: "/organizers/:organizerId/transfer",
        name: "OrganizerTransferWizardPage",
        component: () => import("./pages/Organizer/TransferWizard/OrganizerTransferWizardPage.vue")
      },
      {
        path: "/organizers/create",
        name: "OrganizerCreatePage",
        component: () => import("./pages/Organizer/OrganizerCreatePage.vue")
      },
      {
        path: "/events",
        name: "EventListPage",
        component: () => import("./pages/Event/EventListPage.vue")
      },
      {
        path: "/events/:eventId/:tab?",
        name: "EventShowPage",
        component: () => import("./pages/Event/EventShowPage.vue")
      },
      {
        path: "/events/:eventId/edit",
        name: "EventEditPage",
        component: () => import("./pages/Event/EventEditPage.vue")
      },
      {
        path: "/events/create",
        name: "EventCreatePage",
        component: () => import("./pages/Event/EventCreatePage.vue")
      },
      {
        path: "/suppliers/:supplierId/events/create",
        name: "SupplierEventCreatePage",
        component: () => import("./pages/Event/EventCreatePage.vue")
      },
      {
        path: "/events/campaigns",
        name: "EventCampaignSelectorPage",
        component: () => import("./pages/Event/EventCampaignSelectorPage.vue")
      },
      {
        path: "/sponsors",
        name: "SponsorListPage",
        component: () => import("./pages/Sponsor/SponsorListPage.vue")
      },
      {
        path: "/sponsors/:sponsorId",
        name: "SponsorShowPage",
        component: () => import("./pages/Sponsor/SponsorShowPage.vue")
      },
      {
        path: "/sponsors/:sponsorId/edit",
        name: "SponsorEditPage",
        component: () => import("./pages/Sponsor/SponsorEditPage.vue")
      },
      {
        path: "/sponsors/create",
        name: "SponsorCreatePage",
        component: () => import("./pages/Sponsor/SponsorCreatePage.vue")
      },
      {
        path: "/secret-brands",
        name: "SecretBrandListPage",
        component: () => import("./pages/SecretBrand/SecretBrandListPage.vue")
      },
      {
        path: "/brands",
        name: "BrandListPage",
        component: () => import("./pages/Brand/BrandListPage.vue")
      },
      {
        path: "/brands/create",
        name: "BrandCreatePage",
        component: () => import("./pages/Brand/BrandCreatePage.vue")
      },
      {
        path: "/brands/:brandId",
        name: "BrandShowPage",
        component: () => import("./pages/Brand/BrandShowPage.vue")
      },
      {
        path: "/brands/:brandId/edit",
        name: "BrandEditPage",
        component: () => import("./pages/Brand/BrandEditPage.vue")
      },
      {
        path: "/audience-partnership",
        name: "AudiencePartnershipListPage",
        component: () => import("./pages/AudiencePartnership/AudiencePartnershipListPage.vue")
      },
      {
        path: "/audience-partnership/:audiencePartnershipId",
        name: "AudiencePartnershipShowPage",
        component: () => import("./pages/AudiencePartnership/AudiencePartnershipShowPage.vue")
      },
      {
        path: "/audience-partnership/:audiencePartnershipId/edit",
        name: "AudiencePartnershipEditPage",
        component: () => import("./pages/AudiencePartnership/AudiencePartnershipEditPage.vue")
      },
      {
        path: "/audience-partnership/create",
        name: "AudiencePartnershipCreatePage",
        component: () => import("./pages/AudiencePartnership/AudiencePartnershipCreatePage.vue")
      },
      {
        path: "/pro-service",
        name: "VendorListingListPage",
        component: () => import("./pages/VendorListing/VendorListingListPage.vue")
      },
      {
        path: "/pro-service/:vendorListingId",
        name: "VendorListingShowPage",
        component: () => import("./pages/VendorListing/VendorListingShowPage.vue")
      },
      {
        path: "/pro-service/:vendorListingId/edit",
        name: "VendorListingEditPage",
        component: () => import("./pages/VendorListing/VendorListingEditPage.vue")
      },
      {
        path: "/pro-service/create",
        name: "VendorListingCreatePage",
        component: () => import("./pages/VendorListing/VendorListingCreatePage.vue")
      },
      {
        path: "/recaps",
        name: "RecapListPage",
        component: () => import("./pages/Recap/RecapListPage.vue"),
        children: [
          {
            path: ":recapId/edit",
            name: "RecapEditPage",
            component: () => import("./pages/Recap/RecapEditPage.vue")
          },
        ]
      },
      {
        path: "/payout-board",
        name: "PayoutBoardOfferListPage",
        component: () => import("./pages/PayoutBoard/PayoutBoardOfferListPage.vue")
      },
      {
        path: "/brands-info",
        name: "BrandInfoListPage",
        component: () => import("./pages/BrandInfo/BrandInfoListPage.vue")
      },
      {
        path: "/brands-info/create",
        name: "BrandInfoCreatePage",
        component: () => import("./pages/BrandInfo/BrandInfoCreatePage.vue")
      },
      {
        path: "/brands-info/:brandInfoId",
        name: "BrandInfoShowPage",
        component: () => import("./pages/BrandInfo/BrandInfoShowPage.vue")
      },
      {
        path: "/brands-info/:brandInfoId/edit",
        name: "BrandInfoEditPage",
        component: () => import("./pages/BrandInfo/BrandInfoEditPage.vue")
      },
      {
        path: "/poi",
        name: "POIListPage",
        component: () => import("./pages/POI/POIListPage.vue")
      },
      {
        path: "/poi/:poiId",
        name: "POIShowPage",
        component: () => import("./pages/POI/POIShowPage.vue")
      },
      {
        path: "/poi/:poiId/edit",
        name: "POIEditPage",
        component: () => import("./pages/POI/POIEditPage.vue")
      },
      {
        path: "/poi/create",
        name: "POICreatePage",
        component: () => import("./pages/POI/POICreatePage.vue")
      },
      {
        path: "/campaigns",
        name: "CampaignListPage",
        component: () => import("./pages/Campaign/CampaignListPage.vue")
      },
      {
        path: "/campaigns/create",
        name: "CampaignCreatePage",
        component: () => import("./pages/Campaign/CampaignCreatePage.vue")
      },
      {
        path: '/campaigns/:campaignId',
        name: 'CampaignShowPage',
        component: () => import('./pages/Campaign/CampaignShowPage.vue'),
        redirect: { name: 'CampaignOverviewStage' },
        children: [
          {
            name: 'CampaignOverviewStage',
            path: '/campaigns/:campaignId/overview',
            component: () => import('@ui/Campaign/pipeline/Overview/CampaignOverviewStage.vue'),
            children: [
              {
                path: '/campaigns/:campaignId/overview/:step/edit',
                name: 'CampaignEditWizard',
                component: () => import('@ui/Campaign/CampaignEditWizard.vue')
              }
            ]
          },
          {
            name: 'CampaignEventFeedStage',
            path: '/campaigns/:campaignId/matches/:tab?',
            component: () => import('@ui/Campaign/pipeline/EventFeed/CampaignEventFeedStage.vue'),
            children: [
              {
                name: 'CampaignListingFeedListingShow',
                path: '/campaigns/:campaignId/matches/:tab?/listings/:listingId',
                component: () => import('@ui/Campaign/pipeline/AudienceListing/AudienceListingShow.vue'),
              },
              {
                name: 'CampaignListingFeedListingEdit',
                path: '/campaigns/:campaignId/matches/listings/:listingId/edit',
                component: () => import('@ui/Campaign/pipeline/AudienceListing/CampaignFeedListingEdit.vue'),
              }
            ]
          },
          {
            name: 'CampaignCheckoutStage',
            path: '/campaigns/:campaignId/checkout',
            component: () => import('@ui/Campaign/pipeline/Checkout/CampaignCheckoutStage.vue'),
            children: [
              {
                name: 'CampaignCheckoutListingShow',
                path: '/campaigns/:campaignId/checkout/listings/:listingId',
                component: () => import('@ui/Campaign/pipeline/AudienceListing/AudienceListingShow.vue'),
              },
              {
                name: 'CampaignCheckoutListingEdit',
                path: '/campaigns/:campaignId/checkout/listings/:listingId/edit',
                component: () => import('@ui/Campaign/pipeline/Checkout/CampaignCheckoutListingEdit.vue'),
              },
              {
                name: 'CampaignCheckoutVendorListingShow',
                path: '/campaigns/:campaignId/checkout/pro-services/:vendorListingId',
                component: () => import('@ui/VendorListing/VendorListingShow.vue'),
              },
              {
                name: 'CampaignCheckoutVendorListingEdit',
                path: '/campaigns/:campaignId/checkout/pro-services/:vendorListingId/edit',
                component: () => import('@ui/Campaign/pipeline/Checkout/CampaignCheckoutVendorListingEdit.vue'),
              },
            ]
          },
          {
            name: 'CampaignScheduleStage',
            path: '/campaigns/:campaignId/schedule',
            component: () => import('@ui/Campaign/pipeline/Schedule/CampaignScheduleStage.vue'),
            children: [
              {
                name: 'CampaignScheduleEventEdit',
                path: '/campaigns/:campaignId/schedule/offers/:offerId/edit',
                component: () => import('@ui/Campaign/pipeline/Schedule/CampaignScheduleEventEdit.vue'),
              }
            ]
          },
          {
            name: 'CampaignDashboardStage',
            path: '/campaigns/:campaignId/dashboard',
            component: () => import('@ui/Campaign/pipeline/Dashboard/CampaignDashboardStage.vue'),
          },
        ]
      },
      {
        path: "/campaigns/:campaignId/edit",
        name: "CampaignEditPage",
        component: () => import("./pages/Campaign/CampaignEditPage.vue")
      },
      {
        path: "/offers",
        name: "OfferListPage",
        component: () => import("./pages/Offer/OfferListPage.vue")
      },
      {
        path: "/offers/:offerId",
        name: "OfferShowPage",
        component: () => import("./pages/Offer/OfferShowPage.vue")
      },
      {
        path: "/offers/:offerId/edit",
        name: "OfferEditPage",
        component: () => import("./pages/Offer/OfferEditPage.vue")
      },
      {
        path: "/offers/create",
        name: "OfferCreatePage",
        component: () => import("./pages/Offer/OfferCreatePage.vue")
      },
      {
        path: "/brand-opportunities",
        name: "BrandOpportunityListPage",
        component: () =>
          import("./pages/BrandOpportunity/BrandOpportunityListPage.vue")
      },
      {
        path: "/brand-opportunities/:opportunityId",
        name: "BrandOpportunityShowPage",
        component: () =>
          import("./pages/BrandOpportunity/BrandOpportunityShowPage.vue")
      },
      {
        path: "/brand-opportunities/:opportunityId/edit",
        name: "BrandOpportunityEditPage",
        component: () =>
          import("./pages/BrandOpportunity/BrandOpportunityEditPage.vue")
      },
      {
        path: "/brand-opportunities/create",
        name: "BrandOpportunityCreatePage",
        component: () =>
          import("./pages/BrandOpportunity/BrandOpportunityCreatePage.vue")
      },
      {
        path: "/brand-reps",
        name: "BrandRepListPage",
        component: () => import("./pages/BrandRep/BrandRepListPage.vue")
      },
      {
        path: "/brand-reps/:brandRepId",
        name: "BrandRepShowPage",
        component: () => import("./pages/BrandRep/BrandRepShowPage.vue")
      },
      {
        path: "/brand-reps/:brandRepId/edit",
        name: "BrandRepEditPage",
        component: () => import("./pages/BrandRep/BrandRepEditPage.vue")
      },
      {
        path: "/brand-reps/:brandRepId/password",
        name: "BrandRepPasswordPage",
        component: () => import("./pages/BrandRep/BrandRepPasswordPage.vue")
      },
      {
        path: "/brand-reps/:brandRepId/transfer",
        name: "BrandRepTransferWizardPage",
        component: () => import("./pages/BrandRep/TransferWizard/BrandRepTransferWizardPage.vue")
      },
      {
        path: "/brand-reps/:brandRepId/shopping-cart",
        name: "BrandRepShoppingCartPage",
        component: () => import("./pages/BrandRep/BrandRepShoppingCartPage.vue")
      },
      {
        path: "/brand-reps/create",
        name: "BrandRepCreatePage",
        component: () => import("./pages/BrandRep/BrandRepCreatePage.vue")
      },
      {
        path: "/scanners",
        name: "ScannerListPage",
        component: () => import("./pages/Scanner/ScannerListPage.vue")
      },
      {
        path: "/scanners/:scannerId",
        name: "ScannerShowPage",
        component: () => import("./pages/Scanner/ScannerShowPage.vue")
      },
      {
        path: "/scanners/:scannerId/edit",
        name: "ScannerEditPage",
        component: () => import("./pages/Scanner/ScannerEditPage.vue")
      },
      {
        path: "/scanners/create",
        name: "ScannerCreatePage",
        component: () => import("./pages/Scanner/ScannerCreatePage.vue")
      },
      {
        path: "/activations",
        name: "ActivationListPage",
        component: () => import("./pages/Activation/ActivationListPage.vue")
      },
      {
        path: "/activations/:activationId",
        name: "ActivationShowPage",
        component: () => import("./pages/Activation/ActivationShowPage.vue")
      },
      {
        path: "/activations/:activationId/edit",
        name: "ActivationEditPage",
        component: () => import("./pages/Activation/ActivationEditPage.vue")
      },
      {
        path: "/activations/create",
        name: "ActivationCreatePage",
        component: () => import("./pages/Activation/ActivationCreatePage.vue")
      },
      {
        path: "/organizer-invitations",
        name: "OrganizerInvitationListPage",
        component: () => import("./pages/OrganizerInvitation/OrganizerInvitationListPage.vue")
      },
      {
        path: "/brand-rep-invitations",
        name: "BrandRepInvitationListPage",
        component: () => import("./pages/BrandRepInvitation/BrandRepInvitationListPage.vue")
      },
      {
        path: "/purchase-orders",
        name: "PurchaseOrderListPage",
        component: () => import("./pages/PurchaseOrder/PurchaseOrderListPage.vue")
      },
      {
        path: "/purchase-orders/:purchaseOrderId",
        name: "PurchaseOrderShowPage",
        component: () => import("./pages/PurchaseOrder/PurchaseOrderShowPage.vue"),
        children: [
          {
            name: 'PurchaseOrderLineItemEditPage',
            path: '/purchase-orders/:purchaseOrderId/line-items/:purchaseOrderItemId',
            component: () => import("./pages/PurchaseOrder/PurchaseOrderLineItemEditPage.vue")
          },
          {
            name: 'PurchaseOrderRecapEditPage',
            path: '/purchase-orders/:purchaseOrderId/recaps/:recapId/edit',
            component: () => import("./pages/PurchaseOrder/PurchaseOrderRecapEditPage.vue")
          }
        ]
      },
      {
        path: "/invoices",
        name: "InvoiceListPage",
        component: () => import("./pages/Invoice/InvoiceListPage.vue")
      },
      {
        path: "/invoices/:invoiceId",
        name: "InvoiceShowPage",
        component: () => import("./pages/Invoice/InvoiceShowPage.vue")
      },
      {
        path: "/remittances",
        name: "RemittanceListPage",
        component: () => import("./pages/Remittance/RemittanceListPage.vue")
      },
      {
        path: "/remittances/:remittanceId",
        name: "RemittanceShowPage",
        component: () => import("./pages/Remittance/RemittanceShowPage.vue")
      },
      {
        path: "/purchases",
        name: "PurchaseListPage",
        component: () => import("./pages/Purchase/PurchaseListPage.vue")
      },
      {
        path: "/purchases/:purchaseId",
        name: "PurchaseShowPage",
        component: () => import("./pages/Purchase/PurchaseShowPage.vue")
      },
      {
        path: "/purchases/:purchaseId/edit",
        name: "PurchaseEditPage",
        component: () => import("./pages/Purchase/PurchaseEditPage.vue")
      },
      {
        path: "/shopping-carts",
        name: "ShoppingCartListPage",
        component: () => import("./pages/ShoppingCart/ShoppingCartListPage.vue")
      },
      {
        path: "/event-requests",
        name: "EventRequestListPage",
        component: () => import("./pages/EventRequest/EventRequestListPage.vue")
      },
      {
        path: "/advances",
        name: "AdvanceListPage",
        component: () => import("./pages/Advance/AdvanceListPage.vue")
      },
      {
        path: "/dma",
        name: "DMAListPage",
        component: () => import("./pages/DMA/DMAListPage.vue")
      },
      {
        path: "/universities",
        name: "UniversityListPage",
        component: () => import("./pages/University/UniversityListPage.vue")
      },
      {
        path: "/csv-export",
        name: "CsvExportPage",
        component: () => import("./pages/CsvExport/CsvExportPage.vue")
      },
      {
        path: "/csv-import",
        name: "CsvImportPage",
        component: () => import("./pages/CsvImport/CsvImportPage.vue")
      },
      {
        path: "/reporting-service",
        name: "ReportingServicePage",
        component: () => import("./pages/Report/ReportingServicePage.vue")
      },
      {
        path: "/super-users",
        name: "SuperUserListPage",
        component: () => import("./pages/SuperUser/SuperUserListPage.vue")
      },
      {
        path: "/super-users/create",
        name: "SuperUserCreatePage",
        component: () => import("./pages/SuperUser/SuperUserCreatePage.vue")
      },
      {
        path: "/enabled-features",
        name: "EnabledFeaturesListPage",
        component: () =>
          import("./pages/EnabledFeatures/EnabledFeaturesListPage.vue")
      },
      {
        path: "/enabled-features/create",
        name: "EnabledFeaturesCreatePage",
        component: () =>
          import("./pages/EnabledFeatures/EnabledFeaturesCreatePage.vue")
      },
      {
        path: "/super/variables",
        name: "VariablesListPage",
        component: () => import("./pages/Variables/VariablesListPage.vue")
      },
      {
        path: "/super/dev-stats",
        name: "DevStatsPage",
        component: () => import("./pages/DevStats/DevStatsPage.vue")
      },
      {
        path: "/super/dev-stats/data-integrity",
        name: "DataIntegrityPage",
        component: () => import("./pages/DevStats/DataIntegrityPage.vue")
      },
      {
        path: "/infinite-scroll",
        name: "InfiniteScrollListPage",
        component: () =>
          import("./pages/InfiniteScroll/InfiniteScrollListPage.vue")
      },
      {
        path: "/event-feed/:eventFeedId",
        name: "EventFeedShowPage",
        component: () => import("./pages/EventFeed/EventFeedShowPage.vue"),
        children: [
          {
            name: 'EventFeedDetails',
            path: '/event-feed/:eventFeedId/details/:eventId',
            component: () => import('./pages/EventFeed/EventFeedDetails.vue')
          }
        ]
      },
      {
        path: "/event-schedule/:eventScheduleId",
        name: "EventScheduleShowPage",
        component: () => import("./pages/EventSchedule/EventScheduleShowPage.vue")
      },
      {
        name: "ProfileShowPage",
        path: "/profile",
        component: () =>
          import("@modules/website/pages/Profile/ProfileShowPage.vue"),
        children: [
          {
            name: "MeShowPage",
            path: "/me",
            component: () =>
              import("@modules/website/pages/Profile/MeShowPage.vue")
          },
          {
            name: "TeamShowPage",
            path: "/team",
            component: () =>
              import("@modules/website/pages/Profile/TeamShowPage.vue")
          },
          {
            name: "PasswordEditPage",
            path: "/password",
            component: () =>
              import("@modules/website/pages/Profile/PasswordEditPage.vue")
          }
        ]
      },
    ]
  },
  {
    path: "*",
    redirect: "/"
  }
];

export default SuperRoutes;
